import React, { useEffect, useRef } from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { getEnv } from '../../utils/environment';
import { useHCaptchaContext } from '../../payments';

const HCaptchaContainer = () => {
  const { setHCaptchaToken, setExecuteHCaptcha, executeHCaptcha } = useHCaptchaContext();
  const captchaRef = useRef<HCaptcha>(null);
  const handleHCaptchaVerify = (hCaptchaToken: string) => {
    setHCaptchaToken(hCaptchaToken);
  };
  const handleHCaptchaExpire = () => {
    console.error('hCaptcha Token Expired');
    setHCaptchaToken('');
    setExecuteHCaptcha(false);
  };
  const handleHCaptchaError = (err: any) => {
    console.error(`hCaptcha Error: ${err}`);
  };

  useEffect(() => {
    if (executeHCaptcha) {
      captchaRef.current?.execute();
    }
  }, [executeHCaptcha]);

  return (
    <form>
      <HCaptcha
        sitekey={getEnv().hCaptchaSiteKey}
        size="invisible"
        onVerify={handleHCaptchaVerify}
        onExpire={handleHCaptchaExpire}
        onError={handleHCaptchaError}
        ref={captchaRef}
        id="hcaptchaWidget"
      />
    </form>
  );
};

export default HCaptchaContainer;
